/* src/app/views/template/components/templates/web/web-spotlight-templates/web-spotlight-template-list/web-spotlight-template-list.component.scss */
/*# sourceMappingURL=web-spotlight-template-list.component.css.map */
